"use client";

import { Homepage } from "@/payload-types";
import classNames from "classnames/bind";
import styles from "./HomepageHero.module.css";
import { Button } from "../Button/Button";
import { getImage } from "@/helpers/imageHelper";
import Image from "next/image";

const cx = classNames.bind(styles);

type Props = Homepage["content"]["homepageHero"];

// Extend global window object to include NLX touchpoint function
declare global {
  interface Window {
    openNLXTouchpoint?: () => void;
    nlxTouchpoint?: {
      expanded?: boolean;
      conversationHandler?: unknown;
      teardown?: () => void;
    };
  }
}

export function HomepageHero(props: Props) {
  const handleTouchpointOpen = () => {
    if (typeof window !== "undefined" && window.openNLXTouchpoint) {
      window.openNLXTouchpoint();
    }
  };

  return (
    <div
      className={cx("container")}
      style={{
        backgroundImage: props.backgroundImage
          ? `url(${getImage(props.backgroundImage, "", "full").url})`
          : undefined,
      }}
    >
      {props.introText && <h1 className={cx("intro")}>{props.introText}</h1>}

      <div className={cx("features")}>
        {[props.column1, props.column2].map((column, index) => {
          const image = getImage(column.image, "", "full");
          const hasLinkUrl = column.link?.url;
          const shouldUseTouchpoint = !hasLinkUrl && column.link?.label;

          return (
            <div key={index} className={cx("feature")}>
              <div className={cx("statement")}>
                {column.kicker && (
                  <span className={cx("kicker")}>{column.kicker}</span>
                )}
                {column.text && <h2 className={cx("text")}>{column.text}</h2>}
                {column.link?.label ? (
                  <Button
                    className={cx("button")}
                    variant="secondary-light"
                    onClick={
                      shouldUseTouchpoint ? handleTouchpointOpen : undefined
                    }
                    href={hasLinkUrl ? column.link.url || undefined : undefined}
                  >
                    {column.link.label}
                  </Button>
                ) : null}
              </div>
              {image.url && (
                <Image
                  src={image.url}
                  alt={image.alt ?? ""}
                  width={image.width}
                  height={image.height}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
